import { useCallback, useRef, useState } from "react";

// Mobile-only pull-to-refresh. Returns touch handlers + current pull distance/refreshing state.
export function usePullToRefresh(onRefresh) {
  const [state, setState] = useState({ pull: 0, refreshing: false });
  const startY = useRef(null);
  const pull = useRef(0);

  const onTouchStart = useCallback((e) => {
    if (window.scrollY <= 0 && e.touches.length === 1 && !state.refreshing) {
      startY.current = e.touches[0].clientY;
    } else {
      startY.current = null;
    }
  }, [state.refreshing]);

  const onTouchMove = useCallback((e) => {
    if (startY.current === null) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0 && window.scrollY <= 0) {
      pull.current = Math.min(dy * 0.5, 80);
      setState((s) => ({ ...s, pull: pull.current }));
    }
  }, []);

  const onTouchEnd = useCallback(async () => {
    if (startY.current === null) return;
    startY.current = null;
    if (pull.current >= 50) {
      setState({ pull: 40, refreshing: true });
      try { await onRefresh(); } finally { pull.current = 0; setState({ pull: 0, refreshing: false }); }
    } else {
      pull.current = 0;
      setState((s) => ({ ...s, pull: 0 }));
    }
  }, [onRefresh]);

  return { handlers: { onTouchStart, onTouchMove, onTouchEnd }, pull: state.pull, refreshing: state.refreshing };
}
